export const SET_CURRENT_RECIPE = "SET_CURRENT_RECIPE";
export const ADD_RECIPE = "ADD_RECIPE";

export const SET_CURRENT_RECIPE_WITH_ID = "SET_CURRENT_RECIPE_WITH_ID";

export const GET_SAVED_RECIPES_FROM_FIREBASE = "GET_SAVED_RECIPES_FROM_FIREBASE";
export const ADD_CUSTOM_RECIPE_TO_FIREBASE = "ADD_CUSTOM_RECIPE_TO_FIREBASE";

export const SEARCH_FOR_RECIPES = "SEARCH_FOR_RECIPES";